export default __webpack_public_path__ + "static/media/co-dislike-color.1060f0b8.svg";